import ExpandableFinancing from './financing.vue'

export default ExpandableFinancing
export { default as ExpandableFinancing } from './financing.vue'
